// Action Types
export const FETCH_GEO_WISE_REVENUE_ANALYSIS_REQUEST = "FETCH_GEO_WISE_REVENUE_ANALYSIS_REQUEST";
export const FETCH_GEO_WISE_REVENUE_ANALYSIS_SUCCESS = "FETCH_GEO_WISE_REVENUE_ANALYSIS_SUCCESS";
export const FETCH_GEO_WISE_REVENUE_ANALYSIS_FAILURE = "FETCH_GEO_WISE_REVENUE_ANALYSIS_FAILURE";

// Action Creators
export const fetchReGeoWisevenueAnalysisRequest = (params) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_GEO_WISE_REVENUE_ANALYSIS_REQUEST,
      payload: params,
    });
  };
};
export const fetchGeoWiseRevenueAnalysisSuccess = (data) => ({
  type: FETCH_GEO_WISE_REVENUE_ANALYSIS_SUCCESS,
  payload: data,
});
export const fetchGeoWiseRevenueAnalysisFailure = (error) => ({
  type: FETCH_GEO_WISE_REVENUE_ANALYSIS_FAILURE,
  payload: error,
});
